import { IListPromotion, IListPromotionItem } from '@/features/coupon/types'
import { toast } from 'react-toastify'
import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { useCartStore } from './cart'
import { isUnavailableVoucher } from '@/features/help/utils/helper'
const SAMPLE_VOUCHER = [
  {
    voucher: '-200k',
    expired_date: '2025-12-31',
    total_count: 24,
    used: 12,
    uid: '1',
    image: '/assets/images/fake_voucher.png',
    title: 'Giảm ngay 200k cho đơn từ 1 triệu trở lên',
    is_use: true,
  },
  {
    voucher: '-200k',
    expired_date: '2025-12-31',
    total_count: 24,
    used: 12,
    uid: '5',
    image: '/assets/images/fake_voucher.png',
    title: 'Giảm ngay 200k cho thành viên',
    is_use: true,
    is_fan: true,
  },
  {
    voucher: '-200k',
    expired_date: '2025-12-31',
    total_count: 24,
    used: 12,
    uid: '6',
    image: '/assets/images/fake_voucher.png',
    title: 'Giảm ngay 200k cho đơn từ 1 triệu trở lên',
    is_use: true,
  },
  {
    voucher: '-200k',
    expired_date: '2025-12-31',
    total_count: 24,
    used: 12,
    uid: '7',
    image: '/assets/images/fake_voucher.png',
    title: 'Giảm ngay 200k cho đơn từ 1 triệu trở lên',
    is_use: true,
  },
  {
    voucher: '-200k',
    expired_date: '2025-09-31',
    total_count: 24,
    used: 12,
    uid: '8',
    image: '/assets/images/fake_voucher.png',
    title: 'Giảm ngay 20k cho đơn từ 1 triệu trở lên',
    is_use: true,
  },
  {
    voucher: '-20k',
    expired_date: '2023-12-31',
    total_count: 24,
    used: 12,
    uid: '2',
    image: '/assets/images/fake_voucher.png',
    title: 'Giảm ngay 200k cho đơn từ 1 triệu trở lên',
    is_use: true,
  },
  {
    voucher: '-50k',
    expired_date: '2023-12-31',
    total_count: 24,
    used: 12,
    uid: '3',
    image: '/assets/images/fake_voucher.png',
    title: 'Giảm ngay 200k cho đơn từ 1 triệu trở lên',
    is_use: false,
  },
]
interface VoucherState {
  list: IListPromotionItem[]
  activeVoucher: IListPromotionItem[]
  setActiveVoucher: (vouchers: IListPromotionItem) => Promise<void>
  checkValidFanVoucher: (voucher: IListPromotionItem, isUserFan: boolean) => boolean | undefined
  applyAllVoucher: () => Promise<void>
  getSortedList: () => IListPromotionItem[]
  setListVoucher: (vouchers: IListPromotionItem[]) => void
  isCheckAll: boolean
  loading: boolean
  setLoading: (loading: boolean) => void
  syncActiveVoucher: (vouchers: IListPromotionItem[], isCheckAll?: boolean) => void
  dataCartPriceRule: IListPromotion | null
  setDataCartPriceRule: (data: IListPromotion) => void
  reset: () => void
}
const INITIAL_STATE = {
  list: [],
  isCheckAll: false,
  activeVoucher: [],
  loading: false,
  dataCartPriceRule: {} as IListPromotion,
}
export const useVoucherStore = create<VoucherState>()(
  devtools(
    (set, get) => ({
      list: INITIAL_STATE.list,
      isCheckAll: INITIAL_STATE.isCheckAll,
      activeVoucher: INITIAL_STATE.activeVoucher,
      loading: INITIAL_STATE.loading,
      dataCartPriceRule: INITIAL_STATE.dataCartPriceRule,
      setDataCartPriceRule: (data) => {
        set({ dataCartPriceRule: data })
      },
      setActiveVoucher: async (vouchers) => {
        if (!vouchers || !vouchers?.code) return
        set({ loading: true })
        const { cartData, removeCoupon, addCoupon, swapCoupon } = useCartStore.getState()
        const { activeVoucher } = get()
        const isExist =
          cartData?.applied_coupons?.find((item) => item?.code === vouchers?.code) ||
          activeVoucher?.find((item) => item?.code === vouchers?.code)
        //  nếu có rồi thì xóa, thêm tất cả các voucher còn lại trong list active
        if (isExist) {
          const list = activeVoucher?.filter((item) => item?.code !== vouchers?.code)
          const listCouponHasCode = list?.filter((item) => !!item?.code)
          set({ activeVoucher: list })
          try {
            if (listCouponHasCode?.length > 0) {
              const tempList = list?.map((item) => item?.code)?.join(',')
              await swapCoupon(tempList)
            } else {
              await removeCoupon()
            }
          } catch (err) {
            // rollback khi xóa coupon thất bại
            toast((err as Error)?.message || 'Có lỗi xảy ra, vui lòng thử lại sau!', { theme: 'colored' })
            set({ activeVoucher: activeVoucher })
          } finally {
            set({ loading: false })
          }
          return
        }
        const list = [...activeVoucher, vouchers]
        const tempValidCouponsWithCode = activeVoucher?.filter((item) => !!item?.code) || []
        set({ activeVoucher: list })
        try {
          if (tempValidCouponsWithCode?.length > 0) {
            const newValidCouponsWithCode = list?.filter((item) => !!item?.code) || []
            const tempList = newValidCouponsWithCode?.map((item) => item?.code)?.join(',')
            await swapCoupon(tempList)
          } else {
            await addCoupon(vouchers?.code)
          }
        } catch (err) {
          // rollback khi xóa coupon thất bại
          toast((err as Error)?.message || 'Có lỗi xảy ra, vui lòng thử lại sau!', { theme: 'colored' })

          set({ activeVoucher: activeVoucher })
        } finally {
          set({ loading: false })
        }
      },
      checkValidFanVoucher: (voucher, isUserFan) => {
        // return voucher.is_fan && !isUserFan
        return false
      },
      applyAllVoucher: async () => {
        const { activeVoucher, list } = get()
        const { swapCoupon, removeCoupon } = useCartStore.getState()
        const tempActiveVoucher = activeVoucher || []
        // Lọc ra các voucher hợp lệ (có thể sử dụng)
        const validVouchers = list?.filter((voucher) => {
          return !isUnavailableVoucher(voucher)
        })

        set({ loading: true })

        try {
          // Nếu đã chọn tất cả voucher hợp lệ thì bỏ chọn tất cả
          if (activeVoucher?.length === validVouchers?.length && validVouchers?.length > 0) {
            set({ activeVoucher: [], isCheckAll: false })
            await removeCoupon()
          } else {
            // Chọn tất cả voucher hợp lệ
            set({ activeVoucher: validVouchers, isCheckAll: true })

            if (validVouchers?.length > 0) {
              const tempList = validVouchers?.map((item) => item?.code)?.join(',')
              await swapCoupon(tempList)
            }
          }
        } catch (err) {
          // Rollback khi áp dụng coupon thất bại
          toast((err as Error)?.message || 'Có lỗi xảy ra, vui lòng thử lại sau!', { theme: 'colored' })
          set({
            activeVoucher: tempActiveVoucher,
            isCheckAll: tempActiveVoucher?.length === validVouchers?.length,
          })
        } finally {
          set({ loading: false })
        }
      },
      getSortedList: () => {
        const { list } = get()
        // Cache sorted result
        return list.sort((a, b) => {
          const aHasApplied = a?.is_applied
          const bHasApplied = b?.is_applied
          const aHasCode = a?.code
          const bHasCode = b?.code

          if (aHasApplied && !bHasApplied) return -1
          if (!aHasApplied && bHasApplied) return 1
          if (aHasCode && !bHasCode) return -1
          if (!aHasCode && bHasCode) return 1
          return 0
        })
      },
      setListVoucher: (vouchers) => {
        const sorted = vouchers.sort((a, b) => {
          const aHasApplied = a?.is_applied
          const bHasApplied = b?.is_applied
          const aHasCode = a?.code
          const bHasCode = b?.code
          // Priority 1: Applied vouchers come first
          if (aHasApplied && !bHasApplied) return -1
          if (!aHasApplied && bHasApplied) return 1
          // Priority 2: If both applied or both not applied, check for code
          if (aHasCode && !bHasCode) return -1
          if (!aHasCode && bHasCode) return 1
          // Priority 3: If all conditions are equal, maintain order
          return 0
        })
        set({ list: sorted })
      },
      setLoading: (loading) => {
        set({ loading })
      },
      syncActiveVoucher: (vouchers, isCheckAll) => {
        set({ activeVoucher: vouchers, isCheckAll: isCheckAll })
      },
      reset: () => set({ ...INITIAL_STATE }),
    }),

    {
      name: 'bear-storage',
    }
  )
)
